<template>
  <text-video
    :full-width="true"
    :text="text"
    :variant="variant"
    :video="video"
    :video-left="videoLeft"
  />
</template>

<script>
import TextVideo from "./TextVideo";

export default {
  props: {
    text: Array,
    variant: String,
    video: Object,
    videoLeft: Boolean,
  },
  components: {
    TextVideo,
  },
};
</script>
